import { render, staticRenderFns } from "./ItemEdit.vue?vue&type=template&id=46b44058"
import script from "../../controllers/item/item-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/item/item-edit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports